import { useState } from "react"

import { Button, Flex, Modal, Typography } from "antd"
import dayjs from "dayjs"
import { useSelector } from "react-redux"

import Icon from "../../../../../Icon"
import DescriptorListItem from "../DescriptorListItem/DescriptorListItem"

import "./DescriptorLogs.less"

const { Text } = Typography

const DescriptorLogs = ({ descriptor, service }) => {
  const { isMobile } = useSelector((state) => state.nav)
  const [openLogs, setOpenLogs] = useState(false)

  const logs = descriptor?.logs || []

  return (
    <div className="descriptor-logs">
      <button className="descriptor-logs-trigger" onClick={() => setOpenLogs(true)}>
        <Icon type="info_bubble" className="descriptor-logs-trigger-icon" />
        <Text type="secondary" strong>
          Status logs
        </Text>
      </button>

      <Modal
        classNames={{ content: "clear-bg" }}
        open={openLogs}
        getContainer={() => document.getElementById("main-layout")}
        closeIcon={<Icon type="cross_small" />}
        closable
        onCancel={() => setOpenLogs(false)}
        destroyOnClose
        width={442}
        centered={!isMobile}
        title={
          <Flex vertical gap={8}>
            <Text className="modal-title">Status logs</Text>
            <Text type="secondary">View the latest activity for this descriptor.</Text>
          </Flex>
        }
        rootClassName="descriptor-logs-modal"
        footer={
          <Button size="large" type="primary" onClick={() => setOpenLogs(false)}>
            Got it
          </Button>
        }
      >
        <Flex
          gap={12}
          vertical
          style={{
            maxHeight: "300px"
          }}
        >
          <DescriptorListItem descriptor={descriptor} service={service} withoutLogs />
          <div className="descriptor-logs-table">
            <div className="row header">
              <Text type="secondary" strong>
                Event
              </Text>
              <Text type="secondary" strong>
                Date and time{" "}
              </Text>
            </div>
            {logs.map((log, index) => (
              <div key={index} className="row">
                <Text strong>{log?.log_message}</Text>
                <Text strong>{dayjs(log?.created).format("DD MMM YYYY h:mm A [(UTC)]")}</Text>
              </div>
            ))}
          </div>
        </Flex>
      </Modal>
    </div>
  )
}

export default DescriptorLogs
